import React, { useEffect, useState } from 'react';
import { Modal, Box, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import useAuthenticatedUserService from 'infrastructure/security/authentication/authenticatedUserService';
import LeaveBalances from 'domain/people/employee/leavebalance/BalancesList/LeaveBalances';

interface LeavesDetailsModalProps {
  open: boolean;
  onClose: () => void;
}

const LeavesDetailsModal = ({ open, onClose }: LeavesDetailsModalProps) => {
  const { getUserAlias } = useAuthenticatedUserService();
  const [userAlias, setUserAlias] = useState<string | null>(null);

  useEffect(() => {
    if (open) {
      getUserAlias().then(alias => {
        if (alias) {
          setUserAlias(alias);
        }
      });
    }
  }, [getUserAlias, open]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          width: '90%',
          maxWidth: 1200,
          maxHeight: '90vh',
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 24,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          p={2}
          borderBottom={1}
          borderColor="divider"
          sx={{ position: 'sticky', top: 0, bgcolor: 'background.paper', zIndex: 1 }}
        >
          <Typography variant="h3">Leave balance details</Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
        <Box
          sx={{
            overflow: 'auto',
            padding: 2,
            '& .page-content': { padding: 0, minHeight: '50vh' },
          }}
        >
          <Box>{userAlias && <LeaveBalances id={userAlias} hideShowDetailsButtons />}</Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default LeavesDetailsModal;
